import { DOMAttributes, FocusableElement } from '@react-types/shared';
import React, { useRef } from 'react';
import {
  AriaDialogProps,
  AriaModalOptions,
  FocusScope,
  mergeProps,
  useDialog,
  useModal,
} from 'react-aria';
import useMergedRefs from 'hooks/useMergedRefs';
import { DialogProvider } from '../DialogContext';

export interface DialogContentsProps extends AriaDialogProps, AriaModalOptions {
  children?: React.ReactNode;
  className?: string;
  overlayProps: DOMAttributes<FocusableElement>;
}

const DialogContents = React.forwardRef<HTMLDivElement, DialogContentsProps>(
  ({ overlayProps, children, className, ...props }, ref) => {
    const dialogRef = useRef<HTMLDivElement>(null);
    const mergedRefs = useMergedRefs([ref, dialogRef]);

    const { modalProps } = useModal(props);
    const { dialogProps, titleProps } = useDialog(props, dialogRef);
    const mergedDialogProps = mergeProps(overlayProps, dialogProps, modalProps);

    return (
      <FocusScope contain restoreFocus autoFocus>
        <DialogProvider titleProps={titleProps}>
          <div {...mergedDialogProps} className={className} ref={mergedRefs}>
            {children}
          </div>
        </DialogProvider>
      </FocusScope>
    );
  },
);

export default DialogContents;
